import { faArrowCircleLeft } from "@fortawesome/pro-solid-svg-icons/faArrowCircleLeft";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { MprcButton, MprcButtonProps } from "components/MprcButton";
import * as React from "react";
import { useMprcTheme } from "../MprcThemeProvider";

interface IProps {
    showIcon?: boolean;
    showText?: boolean;
}
export const ButtonBack: React.FC<MprcButtonProps & IProps> = ({ text, title, showIcon = true, showText = true, color = "muted", variant = "contained", ...rest }) => {
    const { theme } = useMprcTheme();
    const lText = showText ? text || theme.buttons.ButtonBack.text : undefined;
    const lTitle = title || theme.buttons.ButtonBack.title;

    return (
        <MprcButton
            color={color}
            variant={variant}
            title={lTitle}
            text={lText}
            startIcon={showIcon ? <FontAwesomeIcon icon={faArrowCircleLeft} /> : undefined}
            {...rest}
        />
    );
};
